import { Component, OnInit } from '@angular/core';
import { MerchantService } from 'src/app/services/merchant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-list-merchant',
  templateUrl: './list-merchant.component.html',
  styleUrls: ['./list-merchant.component.css']
})
export class ListMerchantComponent implements OnInit {
  eventsSubject: Subject<any> = new Subject<any>();

  dominios: any[];
  tipos: any =[];
  displayedColumns: string[] = ['firstName', 'lastName', 'phone', 'tin', 'actions'];
  imageColumn = [ {field: 'photo', header: 'Logo'}]
  columnsToDisplay = [{field: 'firstName', header: 'Nome', type: 'text'}, {field: 'lastName', header: 'Apelido', type: 'text'},
    {field: 'phone', header: 'Telefone', type: 'number'}, {field: 'tin', header: 'Nif', type: 'number'}];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Comerciantes';
  novo = {link: '/comerciantes/criar', nome: 'Novo Comerciante'};
  page: any = {base: null, name: null};
  service;

  constructor(private merchantService: MerchantService,
    private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.merchantService.getAll;
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.email } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.email } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.merchantService.inactive(args.id);
      textConfirm = 'Pretende Desactivar a Comerciante ' + args.firstName + ' '+ args.lastName+ '? Ao desactivar o Comerciante o estado da Comerciante será alterado para INATIVO.';
      status = 'INACTIVE';
      textShow = 'Comerciante DESATIVADO COM SUCESSO';
    }
    else{
      service = this.merchantService.active(args.id);
      textConfirm = 'Pretende Activar o Comerciante ' + args.firstName + ' '+ args.lastName+ '? Ao activar o Comerciante o estado da Comerciante será alterado para ATIVO';
      status = 'ACTIVE';
      textShow = 'Comerciante ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar este Comerciante ' + args.firstName + ' '+ args.lastName+  '? Ao eliminar os dados da Comerciante serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.merchantService.delete(args.email).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }
